module.exports = __webpack_public_path__ + "062d0d2c14b764fe73bd7a68a4d81d99.svg";